import Link from "next/link";
import { tags } from "./tag";

export const articles = [
  {
    id: 1,
    title: "Gusi Berdarah Saat Sikat Gigi? Anda Mungkin Mengalami Gingivitis!",
    thumbnail: "/media/article-1.jpg",
    excerpt:
      "Berapa kali anda sikat gigi dalam sehari? 1 kali? 2 kali? Bahkan ada yang 3 kali? Wah keren sekali ya kalau bisa rajin sampai 3 kali sikat gigi sehari, kapan aja tuh?",
    content: (
      <>
        <p>
          Berapa kali anda sikat gigi dalam sehari? 1 kali? 2 kali? Bahkan ada
          yang 3 kali? Wah keren sekali ya kalau bisa rajin sampai 3 kali sikat
          gigi sehari, kapan aja tuh?
        </p>
        <br />
        <p>
          {`American Dental Association (ADA) merekomendasikan kita untuk menyikat gigi sebanyak 2x2, yaitu 2x sehari selama 2 menit di pagi hari setelah makan dan malam hari sebelum tidur loh. Tapi pernah anda merenungkan, apakah setelah banyaknya sikat gigi itu mulut kita akan bersih dari bakteri dan kuman berbahaya?`}
        </p>
        <br />
        <p>Ternyata jawabannya? Ya dan tidak, yuk kita bahas</p>
        <br />
        <p>
          {`Sistem rongga mulut manusia bekerja dengan konsep yang dinamakan homeostasis (bukan homo ya) yang singkat cerita berarti keseimbangan. Apanya yang seimbang? Mulut kita kan punya kita sendiri?`}
        </p>
        <br />
        <p>
          Ternyata mulut kita adalah rumah bagi puluhan ribu jenis
          mikroorganisme seperti bakteri dan jamur yang beragam loh. Dalam
          keadaan sehat, semua mikroorganisme ini merupakan flora normal yang
          saling memiliki keseimbangan agar menjaga tidak ada satu jenis
          mikroorganisme yang mendominasi satu lainnya.
        </p>
        <br />
        <p>
          {`Terus apa yang terjadi kalau gak seimbang? Banyak hal yang bisa menyebabkan keseimbangan mikroorganisme hancur, contohnya adalah lupa sikat gigi tadi malem (hayo coba diingat-ingat) yang bisa meningkatkan jumlah bakteri didalam mulut hingga ke tingkat yang signifikan.`}
        </p>
        <br />
        <p>
          Bakteri yang tadinya bersifat jinak, karena jumlahnya bertambah ini
          secara dramatis berubah menjadi patogen yang menimbulkan penyakit gigi
          dan mulut, salah satunya penyakit gusi yang membuat gusi kita mudah
          berdarah, terutama saat menyikat gigi.
        </p>
        <br />
        <p>
          Keberadaan bakteri yang bertambah akan memicu respon peradangan yang
          salah satunya menyebabkan pembuluh darah kita melebar dan lebih tipis,
          sehingga sentuhan ringan pun akan membuatnya mudah berdarah.
        </p>
        <br />
        <p>
          Perdarahan pada gusi adalah tanda-tanda awal terjadinya penyakit pada
          gusi dan jaringan penyangga gigi, nantinya hal ini jika dibiarkan akan
          menyebabkan kerusakan tulang penyangga gigi hingga terjadi kegoyangan
          gigi loh!
        </p>
        <br />
        <p>
          Nah tidak perlu khawatir! Ketika masih di tahap gusi yang mudah
          berdarah, kembali rutin menyikat gigi dan melakukan{" "}
          <Link
            className="font-bold"
            href={"/services/scaling-gigi"}
            style={{
              color: "blueviolet",
              textDecoration: "underline",
            }}
          >
            scaling
          </Link>{" "}
          dapat membuat gusi kembali normal dan tidak mudah berdarah.
        </p>
        <br />
        <p>
          Yuk jaga kesehatan gigi kita dengan kebiasaan menyikat gigi yang baik
          dan mengunjungi dokter gigi minimal 6 bulan sekali ~!
        </p>
        <br />
        <br />
        <p className="text-sm text-gray-600 font-nunito">
          {`Referensi : Newman M, Takei H, Klokkevold P, Carranza F. Newman and
          Carranza's clinical periodontology. 12th ed.`}
        </p>
      </>
    ),
    author: "Lutfi Iqsan Nugraha S.K.G",
    authorPhoto: null,
    category: "Education",
    tags: [tags.kesehatangigi],
    createdAt: new Date("2025-04-30T00:00:00Z"),
  },
  {
    id: 2,
    title: "Kenapa Sikat Gigi Itu Harus Malam Hari? Faedahnya Apa Sih?",
    thumbnail: "/media/article-2.jpg",
    excerpt:
      "Berapa umur anda dulu ketika pertama kali belajar menyikat gigi? Jangan-jangan belum pernah belajar, terus coba-coba aja?",
    content: (
      <>
        <p>
          Berapa umur anda dulu ketika pertama kali belajar menyikat gigi?
          Jangan-jangan belum pernah belajar, terus coba-coba aja?
        </p>
        <br />
        <p>
          Negeri ini begitu luas dan terdiri dari beraneka ragam tatanan
          masyarakat. Penyetaraan dan pemerataan edukasi tentang menjaga
          kesehatan gigi dan mulut adalah tantangan tersendiri untuk tenaga
          kesehatan di Indonesia.
        </p>
        <br />
        <p>
          {`Anda mungkin pernah mendengar anjuran, “sikat gigi dua kali sehari pagi dan malam selama 2 menit” (kalau belum pernah, berarti kami jadi yang pertama buat anda, yey!).`}
        </p>
        <br />
        <p>
          {`Anjuran tersebut merupakan hasil dari riset dan data yang dikumpulkan
          dan diterbitkan oleh American Dental Association (ADA) untuk membentuk
          kebiasaan menyikat gigi terbaik yang dapat kita terapkan, tetapi
          mengapa harus begitu? Mari kita bahas.`}
        </p>
        <br />
        <p>
          {`Walaupun sikat gigi dua kali sehari direkomendasikan, penelitian
          menunjukkan bahwa sikat gigi di malam hari sebelum tidur jauh lebih
          penting dibanding sikat gigi pagi setelah sarapan ( bukan alasan buat
          gak sikat gigi pagi ya!).`}
        </p>
        <br />
        <p>
          Hal ini dikarenakan adanya perubahan Ph mulut menjadi lebih asam
          ketika tidur, jika keadaan ini terjadi dalam keadaan bacterial
          load/jumlah bakteri yang sedang tinggi, risiko terjadinya gigi
          berlubang akan meningkat secara signifikan.
        </p>
        <br />
        <p>
          {`Selain itu keberadaan fluoride dalam aliran saliva ketika ph mulut
          turun dibawah tingkat kritis enamel, dapat membantu mengembalikan
          mineral gigi yang hilang dengan fluoride yang jauh lebih tahan dengan
          asam dibanding kristal hidroksiapatit sebelumnya ( bahan penyusun
          enamel gigi).`}
        </p>
        <br />
        <p>
          Gimana, menarik bukan? Semoga dengan pengetahuan baru hari ini, kita
          semua jadi lebih niat dan rajin untuk menyempatkan sikat gigi yang
          rutin dengan baik ya! Jangan lupa rutin kontrol ke{" "}
          <button
            className="font-bold"
            onClick={() => window.open("https://wa.me/6287711416106", "_blank")}
            style={{
              color: "blueviolet",
              textDecoration: "underline",
            }}
          >
            dokter gigi
          </button>{" "}
          juga!
        </p>
        <br />
        <br />
        <p className="text-sm text-gray-600 font-nunito">
          {`Referensi : Sahoo SR, Nandini DB, Basandi PS, Selvamani M, Donoghue M.
          A Comparison of Pre- and Postbreakfast Tooth Brushing in Caries
          Prevention through the Estimation of Streptococcus mutans Counts: A
          Prospective Clinical and Microbiological Study. J Microsc Ultrastruct.
          2022; Mount, G. J., Hume, W. R., Ngo, H., & Wolff, M. S. (2016).
          Preservation and restoration of tooth structure 3rd ed. Wiley
          Blackwell.; American Dental Association (ADA)`}
        </p>
      </>
    ),
    author: "Lutfi Iqsan Nugraha S.K.G",
    authorPhoto: null,
    category: "Education",
    tags: [tags.kesehatangigi],
    createdAt: new Date("2025-04-30T00:00:00Z"),
  },
  {
    id: 3,
    title: "Kenapa Periksa Gigi Secara Rutin Itu Penting?",
    thumbnail: "/media/article-3.jpg",
    excerpt:
      "Banyak orang hanya pergi ke dokter gigi saat sudah merasa sakit gigi atau gusi berdarah. Padahal, periksa gigi secara rutin setiap enam bulan justru jauh lebih penting untuk menjaga kesehatan mulut secara menyeluruh. Pemeriksaan rutin membantu mendeteksi masalah sejak dini, bahkan sebelum muncul rasa sakit.",
    content: (
      <>
        <p>
          Banyak orang hanya pergi ke dokter gigi saat sudah merasa sakit gigi
          atau gusi berdarah. Padahal, periksa gigi secara rutin setiap enam
          bulan justru jauh lebih penting untuk menjaga kesehatan mulut secara
          menyeluruh. Pemeriksaan rutin membantu mendeteksi masalah sejak dini,
          bahkan sebelum muncul rasa sakit.
        </p>
        <br />
        <p>
          Masalah seperti gigi berlubang, penumpukan plak, atau radang gusi
          seringkali berkembang tanpa gejala awal yang terasa. Jika dibiarkan,
          kerusakannya bisa menyebar dan perawatannya menjadi lebih rumit dan
          mahal. Dengan kontrol rutin, dokter gigi bisa membersihkan karang
          gigi, mengecek kondisi tambalan, serta memastikan tidak ada infeksi
          tersembunyi.
        </p>
        <br />
        <p>
          Selain menjaga kesehatan mulut, periksa gigi juga berdampak pada
          kesehatan tubuh secara keseluruhan. Infeksi di mulut bisa menyebar ke
          organ lain bila tidak ditangani. Jadi, jangan tunggu sakit dulu untuk
          datang ke klinik gigi. Jadwalkan kontrol rutin agar gigi tetap sehat
          dan senyum tetap percaya diri.
        </p>
      </>
    ),
    author: "Hanan Tsabitah",
    authorPhoto: null,
    category: "Education",
    tags: [tags.kesehatangigi],
    createdAt: new Date("2025-04-28T00:00:00Z"),
  },
  {
    id: 4,
    title: "Bedanya Scaling dan Pembersihan Biasa",
    thumbnail: "/media/article-4.jpg",
    excerpt:
      "Banyak pasien yang mengira bahwa scaling hanyalah bentuk lain dari menyikat gigi di rumah. Padahal, scaling adalah prosedur profesional untuk membersihkan karang gigi yang keras dan menempel di sela-sela gigi maupun garis gusi. Karang gigi terbentuk dari sisa makanan dan plak yang mengeras, dan tidak bisa hilang hanya dengan sikat gigi biasa.",
    content: (
      <>
        <p>
          Banyak pasien yang mengira bahwa scaling hanyalah bentuk lain dari
          menyikat gigi di rumah. Padahal, scaling adalah prosedur profesional
          untuk membersihkan karang gigi yang keras dan menempel di sela-sela
          gigi maupun garis gusi. Karang gigi terbentuk dari sisa makanan dan
          plak yang mengeras, dan tidak bisa hilang hanya dengan sikat gigi
          biasa.
        </p>
        <br />
        <p>
          Proses scaling menggunakan alat khusus yang bisa memecah dan
          mengangkat karang gigi tanpa merusak permukaan gigi. Biasanya, scaling
          dilakukan setiap 6 hingga 12 bulan tergantung dari kondisi
          masing-masing individu. Hasilnya, gigi menjadi lebih bersih, gusi
          lebih sehat, dan bau mulut pun berkurang karena sumber bakteri
          dibersihkan.
        </p>
        <br />
        <p>
          Jika karang gigi dibiarkan terlalu lama, bisa menyebabkan radang gusi
          yang berdarah, bahkan bisa berlanjut menjadi penyakit gusi yang lebih
          parah. Oleh karena itu, meskipun tidak terasa sakit, scaling tetap
          penting sebagai bagian dari perawatan gigi rutin yang tidak boleh
          diabaikan.
        </p>
      </>
    ),
    author: "Hanan Tsabitah",
    authorPhoto: "/media/Hanan-Tsabitah-1.png",
    category: "Education",
    tags: [tags.kesehatangigi],
    createdAt: new Date("2025-04-27T00:00:00Z"),
  },
  {
    id: 5,
    title: "5 Kebiasaan Sederhana untuk Gigi Lebih Sehat",
    thumbnail: "/media/article-5.jpg",
    excerpt:
      "Menjaga kesehatan gigi sebenarnya tidak sulit dan bisa dimulai dari kebiasaan sehari-hari yang sederhana.",
    content: (
      <>
        <p>
          Menjaga kesehatan gigi sebenarnya tidak sulit dan bisa dimulai dari
          kebiasaan sehari-hari yang sederhana. Salah satunya adalah menyikat
          gigi dua kali sehari, terutama setelah sarapan dan sebelum tidur.
          Gunakan pasta gigi yang mengandung fluoride dan pastikan teknik
          menyikat dilakukan dengan benar.
        </p>
        <br />
        <p>
          Selain menyikat gigi, penting juga untuk memperhatikan pola makan.
          Terlalu sering mengonsumsi makanan dan minuman manis bisa mempercepat
          proses pembentukan plak dan karang gigi. Minum air putih setelah makan
          dapat membantu membersihkan sisa makanan yang menempel di sela gigi,
          apalagi jika belum sempat menyikat gigi.
        </p>
        <br />
        <p>
          Kesehatan gigi juga tidak lepas dari kebiasaan rutin memeriksakan diri
          ke dokter gigi. Dengan kombinasi perawatan harian yang benar dan
          pemeriksaan profesional, Anda bisa menjaga gigi tetap kuat, bersih,
          dan terhindar dari masalah jangka panjang. Gigi yang sehat mendukung
          penampilan dan juga kesehatan tubuh secara umum.
        </p>
      </>
    ),
    author: "Hanan Tsabitah",
    authorPhoto: "/media/Hanan-Tsabitah-1.png",
    category: "Education",
    tags: [tags.kesehatangigi],
    createdAt: new Date("2025-04-30T00:00:00Z"),
  },
  {
    id: 6,
    title: "Anak Takut ke Dokter Gigi? Ini Solusinya!",
    thumbnail: "/media/article-6.jpg",
    excerpt:
      "Wajar jika anak merasa cemas atau takut saat pertama kali mengunjungi dokter gigi. Suara alat, bau khas klinik, dan suasana asing bisa membuat anak merasa tidak nyaman. Namun, hal ini bisa dicegah jika orang tua mengenalkan dokter gigi sejak dini, bahkan sebelum ada keluhan.",
    content: (
      <>
        <p>
          Wajar jika anak merasa cemas atau takut saat pertama kali mengunjungi
          dokter gigi. Suara alat, bau khas klinik, dan suasana asing bisa
          membuat anak merasa tidak nyaman. Namun, hal ini bisa dicegah jika
          orang tua mengenalkan dokter gigi sejak dini, bahkan sebelum ada
          keluhan.
        </p>
        <br />
        <p>
          Membawa anak untuk sekadar berkenalan dengan lingkungan klinik dan
          dokter gigi bisa membangun rasa percaya. Jika pengalaman pertamanya
          menyenangkan, anak cenderung lebih rileks dan tidak takut di kunjungan
          berikutnya. Ceritakan juga pada anak bahwa dokter gigi adalah teman
          yang membantu menjaga gigi tetap kuat dan sehat, bukan sosok yang
          menakutkan.
        </p>
        <br />
        <p>
          Pendekatan yang ramah anak dari dokter, serta dukungan dari orang tua,
          sangat berperan dalam membentuk persepsi positif terhadap perawatan
          gigi. Beberapa anak juga merasa senang bila diberi hadiah kecil
          setelah selesai diperiksa. Hal-hal sederhana seperti ini bisa
          menciptakan kebiasaan sehat sejak dini, dan membuat anak tidak trauma
          dengan dokter gigi.
        </p>
      </>
    ),
    author: "Hanan Tsabitah",
    authorPhoto: "/media/Hanan-Tsabitah-1.png",
    category: "Education",
    tags: [tags.dentalanak],
    createdAt: new Date("2025-04-27T00:00:00Z"),
  },
  {
    id: 7,
    title: "Kapan Harus Pasang Behel?",
    thumbnail: "/media/article-7.jpg",
    excerpt:
      "Behel atau kawat gigi tidak hanya bertujuan untuk mempercantik senyum, tetapi juga untuk memperbaiki fungsi gigi yang tidak sejajar. Banyak orang bertanya, kapan waktu yang tepat untuk memasang behel? Jawabannya tergantung dari kondisi masing-masing individu, tapi biasanya masalah seperti gigi berjejal, gigi depan menonjol, atau rahang atas dan bawah tidak sejajar bisa menjadi tanda perlunya perawatan ortodonti.",
    content: (
      <>
        <p>
          Behel atau kawat gigi tidak hanya bertujuan untuk mempercantik senyum,
          tetapi juga untuk memperbaiki fungsi gigi yang tidak sejajar. Banyak
          orang bertanya, kapan waktu yang tepat untuk memasang behel?
          Jawabannya tergantung dari kondisi masing-masing individu, tapi
          biasanya masalah seperti gigi berjejal, gigi depan menonjol, atau
          rahang atas dan bawah tidak sejajar bisa menjadi tanda perlunya
          perawatan ortodonti.
        </p>
        <br />
        <p>
          Konsultasi ke dokter gigi adalah langkah pertama yang penting. Dokter
          akan melakukan pemeriksaan langsung dan biasanya menyarankan rontgen
          untuk melihat posisi akar gigi. Dari situ, akan disusun rencana
          perawatan yang sesuai, termasuk jenis behel yang cocok, estimasi waktu
          pemakaian, dan perkiraan biayanya.
        </p>
        <br />
        <p>
          Semakin dini masalah gigi diperbaiki, hasilnya biasanya akan lebih
          cepat dan optimal. Tidak harus menunggu dewasa, anak-anak pun bisa
          mulai diperiksa sejak usia 7 tahun untuk melihat apakah ada indikasi
          yang perlu ditangani lebih awal. Jadi, jangan ragu untuk konsultasi,
          karena senyum indah dimulai dari gigi yang sehat dan teratur.
        </p>
      </>
    ),
    author: "Hanan Tsabitah",
    authorPhoto: "/media/Hanan-Tsabitah-1.png",
    category: "Education",
    tags: [tags.tipsperawatan],
    createdAt: new Date("2025-04-27T00:00:00Z"),
  },
  {
    id: 8,
    title:
      "Natura Goes to School: Edukasi Gigi Seru untuk Si Kecil di TK Indonesia Playschool",
    thumbnail: "/csr/2022_NGTS_TK Indonesia Playschool_1.JPG",
    excerpt:
      "Tim dokter gigi Natura melakukan pemeriksaan gigi gratis kepada anak-anak dengan pendekatan yang ringan dan menyenangkan.",
    content: (
      <>
        <p>
          Pada 8 November 2022, Natura Dental Center mengunjungi TK Indonesia
          Playschool sebagai bagian dari Natura Goes to School Project— Langkah
          konkrit kami untuk mengedukasi anak-anak tentang pentingnya menjaga
          kesehatan gigi dan mulut sejak usia dini.
        </p>
        <br />
        <p>
          Tim dokter gigi Natura melakukan pemeriksaan gigi gratis kepada
          anak-anak dengan pendekatan yang ringan dan menyenangkan. Anak-anak
          diajak bermain sambil diperiksa, agar mereka merasa nyaman dengan
          kehadiran dokter gigi sejak kecil.
        </p>
        <br />
        <p>
          Tak hanya itu, kami juga memberikan penyuluhan seru dan interaktif
          seputar kebiasaan menyikat gigi yang benar. Dengan bantuan boneka,
          lagu, dan cerita lucu. Anak-anak diajak belajar sambil tertawa
          sehingga memudahkan anak untuk memahami pesan yang diberikan.
        </p>
        <br />
        <p>
          Kegiatan ini disambut baik oleh guru dan wali murid, karena sadar
          bahwa kebiasaan baik harus dimulai dari usia dini. Kami pun merasa
          senang bisa menjadi bagian dari proses tumbuh kembang anak yang lebih
          sehat dan percaya diri dengan senyum mereka.
        </p>
        <br />
        <p>
          Natura Dental Center akan terus melanjutkan program edukasi seperti
          ini ke berbagai sekolah, karena Senyum alami dan sehat itu dibentuk
          sejak dini.
        </p>
      </>
    ),
    author: "Hanan Tsabitah",
    authorPhoto: "/media/Hanan-Tsabitah-1.png",
    category: "Community Action",
    tags: [tags.csr],
    createdAt: new Date("2022-11-08T00:00:00Z"),
  },
  {
    id: 9,
    title:
      "Natura Goes to School: Menanamkan Kebiasaan Merawat Gigi Sejak Dini di TK Binakheir",
    thumbnail: "/csr/2022_NGTS_TK Binakheir_1.jpg",
    excerpt:
      "Kami melakukan pemeriksaan gigi gratis untuk seluruh anak dengan pendekatan yang menyenangkan. Anak-anak diajak bermain sambil diperiksa, sehingga mereka merasa nyaman dan tidak takut.",
    content: (
      <>
        <p>
          Pada 19 Desember 2022, Natura Dental Center mengunjungi TK Binakheir
          dalam rangka Natura Goes to School Project. Kegiatan ini bertujuan
          untuk mengedukasi anak-anak tentang pentingnya menjaga kesehatan gigi
          dan mulut sejak usia dini, agar mereka tumbuh dengan kebiasaan baik
          hingga tumbuh dewasa.
        </p>
        <br />
        <p>
          Kami melakukan pemeriksaan gigi gratis untuk seluruh anak dengan
          pendekatan yang menyenangkan. Anak-anak diajak bermain sambil
          diperiksa, sehingga mereka merasa nyaman dan tidak takut. Kami ingin
          menunjukkan bahwa pergi ke dokter gigi tidak menakutkan dan bisa
          menjadi pengalaman yang menyenangkan.
        </p>
        <br />
        <p>
          Selain pemeriksaan, kami juga memberikan penyuluhan dan edukasi
          mengenai cara menyikat gigi yang benar. Dengan menggunakan metode yang
          interaktif dan seru, seperti lagu dan cerita lucu, anak-anak diajak
          untuk memahami pentingnya menjaga kebersihan gigi dengan cara yang
          mudah mereka ingat.
        </p>
        <br />
        <p>
          Antusiasme anak-anak, guru, dan orang tua sangat luar biasa. Kami
          sangat senang bisa membantu anak-anak di TK Binakheir untuk memiliki
          senyum sehat dan percaya diri.
        </p>
        <br />
        <p>
          Natura Dental Center akan terus hadir di berbagai sekolah untuk
          menyebarkan edukasi kesehatan gigi kepada anak-anak, karena kami
          percaya bahwa Senyum alami dan sehat itu dibentuk sejak dini.
        </p>
      </>
    ),
    author: "Hanan Tsabitah",
    authorPhoto: "/media/Hanan-Tsabitah-1.png",
    category: "Community Action",
    tags: [tags.csr],
    createdAt: new Date("2022-12-19T00:00:00Z"),
  },
  {
    id: 10,
    title:
      "Natura Goes to School: Serunya Edukasi dan Pemeriksaan Gigi di Zamzam Syifa Boarding School",
    thumbnail: "/csr/2023_NGTS_Zamzam Syifa Boarding School_1.jpg",
    excerpt:
      "Sebanyak 88 siswa terdaftar untuk mengikuti pemeriksaan gigi, yang dilakukan langsung di ruang kelas yang disulap menjadi ruang periksa.",
    content: (
      <>
        <p>
          Pada Rabu, 9 Agustus 2023, Natura Dental Center kembali menjalankan
          salah satu misi CSR kami melalui Natura Goes to School Project, yang
          kali ini menyapa para siswa di Zamzam Syifa Boarding School. Kegiatan
          berlangsung dari pukul 13.00 hingga 17.00 WIB, menghadirkan kombinasi
          antara pemeriksaan gigi gratis dan edukasi kesehatan gigi yang
          interaktif.
        </p>
        <br />
        <p>
          Sebanyak 88 siswa terdaftar untuk mengikuti pemeriksaan gigi, yang
          dilakukan langsung di ruang kelas yang disulap menjadi ruang periksa.
          Siswa ikhwan dan akhwat mendapat pelayanan yang setara, dengan catatan
          khusus bahwa beberapa siswa belum sempat mengisi data identitas
          lengkap.
        </p>
        <br />
        <p>
          Tak hanya pemeriksaan, suasana makin hidup dengan penyuluhan seputar
          kesehatan gigi yang dikemas menyenangkan. Ada sesi tanya jawab, kuis,
          hingga kontes berhadiah yang membuat para siswa antusias dan semangat
          belajar. Edukasi disampaikan dengan bahasa ringan dan penuh semangat,
          agar siswa lebih mudah memahami pentingnya merawat gigi sejak dini.
        </p>
        <br />
        <p>
          Kegiatan ini menjadi bukti nyata komitmen Natura Dental Center untuk
          terus memberikan dampak positif melalui pendekatan yang solutif,
          edukatif, dan berempati — karena kami percaya, Senyum alami dan sehat
          itu dibentuk sejak dini
        </p>
      </>
    ),
    author: "Hanan Tsabitah",
    authorPhoto: "/media/Hanan-Tsabitah-1.png",
    category: "Community Action",
    tags: [tags.csr],
    createdAt: new Date("2023-08-09T00:00:00Z"),
  },
  // {
  //   id: 11,
  //   title: "Lorem ipsum",
  //   thumbnail: "/csr/2022_NGTS_TK Indonesia Playschool_1.JPG",
  //   excerpt:
  //     "lorem ipsum",
  //   content: (
  //     <>
  //       <p>
  //         Lorem ipsum dolor sit amet
  //       </p>
  //       <br />
  //       <p>
  //         Lorem ipsum dolor sit amet
  //       </p>
  //       <br />
  //       <p>
  //         Lorem ipsum dolor sit amet
  //       </p>
  //     </>
  //   ),
  //   author: "Hanan Tsabitah",
  //   authorPhoto: "/media/Hanan-Tsabitah-1.png",
  //   category: "Community Action",
  //   tags: ["#CSR"],
  //   createdAt: new Date("2024-01-01T00:00:00Z"),
  // },
  // {
  //   id: 12,
  //   title: "Lorem ipsum",
  //   thumbnail: "/csr/2022_NGTS_TK Indonesia Playschool_1.JPG",
  //   excerpt:
  //     "lorem ipsum",
  //   content: (
  //     <>
  //       <p>
  //         Lorem ipsum dolor sit amet
  //       </p>
  //       <br />
  //       <p>
  //         Lorem ipsum dolor sit amet
  //       </p>
  //       <br />
  //       <p>
  //         Lorem ipsum dolor sit amet
  //       </p>
  //     </>
  //   ),
  //   author: "Hanan Tsabitah",
  //   authorPhoto: "/media/Hanan-Tsabitah-1.png",
  //   category: "Community Action",
  //   tags: ["#CSR"],
  //   createdAt: new Date("2024-02-01T00:00:00Z"),
  // },
  // {
  //   id: 13,
  //   title: "Lorem ipsum",
  //   thumbnail: "/csr/2022_NGTS_TK Indonesia Playschool_1.JPG",
  //   excerpt:
  //     "lorem ipsum",
  //   content: (
  //     <>
  //       <p>
  //         Lorem ipsum dolor sit amet
  //       </p>
  //       <br />
  //       <p>
  //         Lorem ipsum dolor sit amet
  //       </p>
  //       <br />
  //       <p>
  //         Lorem ipsum dolor sit amet
  //       </p>
  //     </>
  //   ),
  //   author: "Hanan Tsabitah",
  //   authorPhoto: "/media/Hanan-Tsabitah-1.png",
  //   category: "Community Action",
  //   tags: ["#CSR"],
  //   createdAt: new Date("2024-02-01T00:00:00Z"),
  // },
  //{
  //   id: 999,
  //   title: "Lorem ipsum",
  //   thumbnail: "/csr/2022_NGTS_TK Indonesia Playschool_1.JPG",
  //   excerpt:
  //     "lorem ipsum",
  //   content: (
  //     <>
  //       <p>
  //         Lorem ipsum dolor sit amet
  //       </p>
  //       <br />
  //       <p>
  //         Lorem ipsum dolor sit amet
  //       </p>
  //       <br />
  //       <p>
  //         Lorem ipsum dolor sit amet
  //       </p>
  //     </>
  //   ),
  //   author: "Hanan Tsabitah",
  //   authorPhoto: "/media/Hanan-Tsabitah-1.png",
  //   category: "Community Action",
  //   tags: ["#CSR"],
  //   createdAt: new Date("2024-02-01T00:00:00Z"),
  // },
];
